import { render, staticRenderFns } from "./ProfileSidebar.vue?vue&type=template&id=2fc944c2&scoped=true"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProfileSidebar.vue?vue&type=style&index=0&id=2fc944c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc944c2",
  null
  
)

export default component.exports